<div class="header-group icon-left icon-m ui-icon-config">
    <h2>{{msg 'sensor'}}</h2>
</div>
<div class="inlineGroup fields">
    <field-checkbox name="watchingDefects" col="6 12"></field-checkbox>
    <field-checkbox name="watchingIntrusions" col="6 12"></field-checkbox>
</div>
